module.exports = __webpack_public_path__ + "img/taiyo4s.030aa18f.gif";